<template>
		<div>

				<template v-if="!base_loading">
            <h3 style="margin-bottom: 40px;">Отчет по конкурсу "{{ competition.name }}"</h3>

            <div class="items">
                <div class="item" :key="category.id" v-for="category in competition.categories" :class="category.id === active_category_id ? 'active' : ''" @click="changeCategory(category.id)">
                    {{ category.name }}
                </div>
            </div>

						<div style="margin-bottom: 30px;">
                <BaseCompetitionTourChecker
                        @changeValue="(value) => tour=value"
                        :value="tour"
                ></BaseCompetitionTourChecker>
						</div>

				</template>
        <template v-else>
						<Spin></Spin>
				</template>



				<template v-if="tour.length > 0">
            <div v-if="!loading">

                <a class="button4" style="margin-bottom: 20px;" @click="exportToExcel">Экспорт в Excel</a>

                <div class="table_wrapper">
                    <Table
                            :columns="expertColumns"
                            :data-source="rows"
                            sticky
                            :pagination="false"
                            :scroll="{ x: '100%', y: 400 }"
                    >
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key.startsWith('expert')">
                                <div>
                                    {{ getScoreByExpert(column.title, record.scores)['score'] }}

                                    <div class="table_icons__wrapper">
                                        <template v-if="getScoreByExpert(column.title, record.scores)['comments'].length > 0">
                                            <CommentOutlined @click="onShowModal(getScoreByExpert(column.title, record.scores)['comments'])" style="cursor: pointer"></CommentOutlined>
                                        </template>
                                        <template v-if="getScoreByExpert(column.title, record.scores)['favorite']">
                                            <StarFilled></StarFilled>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </Table>
                </div>

                <Modal
                        v-model:visible="isModalVisible"
                        :footer="null"
                >
                    <Table
                            :columns="columns_vote"
                            :data-source="currentVotes"
                    ></Table>
                </Modal>

            </div>
            <Spin v-else></Spin>
				</template>
		</div>
</template>

<script setup>
import {computed, ref, watch } from "vue";
import axios from "axios";
import {Spin, Table, Modal} from "ant-design-vue";
import {
 CommentOutlined, StarFilled
} from '@ant-design/icons-vue';
import BaseCompetitionTourChecker from "@/components/Base/BaseCompetitionTourChecker.vue";
//import {Excel} from "antd-table-saveas-excel";
import * as XLSX from 'xlsx';


let competition = ref(null);
let loading = ref(false);
let base_loading = ref(false);
let rows = ref([]);
let columns = ref([]);
let isModalVisible = ref(false);
let currentVotes = ref([]);
let active_category_id = ref('');
let tour = ref('');


async function getData() {
  base_loading.value = true;

  const response_competition = await axios.get('/api/competitions/' + window.competitionId);
  competition.value = response_competition.data;
  active_category_id.value = response_competition.data.categories[0].id;

  if (tour.value.length > 0) {
    await get_competition_scores();
  }

  base_loading.value = false;
}
getData();

async function get_competition_scores() {
  loading.value = true;
  const response = await axios.get('/competition/get_report_data/' + window.competitionId + '/' + active_category_id.value + '/' + tour.value);
  rows.value = response.data.rows;
  columns.value = response.data.columns;
	loading.value = false;
}

watch(() => tour.value, (newValue, oldValue) => {
  get_competition_scores();
})

const competitionId = computed(() => {
  return window.competitionId;
});

const expertColumns = computed(() => {
  let res = [
    {
      title: 'Проект',
      dataIndex: 'project_name',
      key: 'project_name',
			width: '150px',
			fixed: true
    },
    {
      title: 'Средний балл',
      dataIndex: 'avgProjectScore',
      key: 'avgProjectScore',
      width: '100px',
      sorter: (a, b) => a.avgProjectScore - b.avgProjectScore
    },
    {
      title: 'Количество звезд',
      dataIndex: 'totalExpertsStars',
      key: 'totalExpertsStars',
      width: '120px',
      sorter: (a, b) => a.totalExpertsStars - b.totalExpertsStars
    }
  ]

  const vals = columns.value.map((item, index) => {
    return {
      title: item,
      dataIndex: 'expert' + index,
      key: 'expert' + index,
      width: '100px',
      sorter: (a, b) => {
				return getScoreByExpert(item, a.scores)['score'] - getScoreByExpert(item, b.scores)['score']}
    }
  })

  //Соединяем два массива
  res = res.concat(vals)
  return res
})

const expertColumnsExcel = computed(() => {
  let res = [
    {
      title: 'Проект',
      dataIndex: 'project_name',
      key: 'project_name',
      width: '150px',
      fixed: true
    }
  ];
  return res;
})

const columns_vote = [
  {
		title: 'Критерий',
		dataIndex: 'criterion',
		key: 'criterion'
	},
  {
    title: 'Комментарий',
    dataIndex: 'comment',
    key: 'comment'
  },
]

function getScoreByExpert(expertName, scores) {
  const score = scores.find((item) => {
    return item.expertName === expertName;
  })
  return score;
}

async function changeCategory(categoryId) {
	active_category_id.value = categoryId;
	if (tour.value.length > 0) {
		await get_competition_scores();
	}
}


function onShowModal(votes) {
  currentVotes.value = votes;
  isModalVisible.value = true;
}

function exportToExcel() {
  //console.log(expertColumnsExcel.value, to_excel_row_data.value);

  // const data = [
  //   { name: 'John', age: 30, city: 'New York' },
  //   { name: 'Anna', age: 22, city: 'London' },
  //   { name: 'Mike', age: 32, city: 'Chicago' }
  // ];

  // Создаем рабочий лист
  const ws = XLSX.utils.json_to_sheet(to_excel_row_data.value);

  // Создаем рабочую книгу
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  // Генерируем файл Excel
  XLSX.writeFile(wb, 'data.xlsx');

  // const excel = new Excel();
	//
  // excel
  //   .addSheet(`Лист1`)
  //   .addColumns(expertColumnsExcel.value)
  //   .addDataSource(to_excel_row_data.value, {
  //     str2Percent: true
  //   })
  //   // .addDataSource([{project_name:'123'}], {
  //   //   str2Percent: true
  //   // })
  //   .saveAs(`Data.xlsx`);
}



const to_excel_row_data = computed(() => {
  let header_items = ['Проект', 'Средний балл', 'Количество звезд'];
  expertColumns.value.forEach((column) => {
    if (column.key.startsWith('expert')) {
			header_items.push(column.title);
    }
  })
  header_items.push('Компания-заявитель');
  header_items.push('Регион компании - заявителя');
  header_items.push('Имя режиссера');
  header_items.push('Регион режиссера');

	let res = [header_items];

  rows.value.forEach((item)=> {

    let row_items = [item.project_name,item.avgProjectScore,item.totalExpertsStars];

    expertColumns.value.forEach((column) => {

      if (column.key.startsWith('expert')) {
        //Присоединяем фаворит ли проект
        //row_items.push(getScoreByExpert(column.title, item.scores)['score'] + ' (' + getScoreByExpert(column.title, item.scores)['favorite'] + ')');

        let scoreData = getScoreByExpert(column.title, item.scores);
        let scoreText = scoreData['score'];

        if (scoreData['favorite']) {
          scoreText += ' (Фаворит)';
        }
				//Комментарии присоединяем
				if (scoreData['comments'].length > 0) {
          let commentsText = scoreData['comments'].map(comment => comment.comment).join(' | ');
          scoreText += ' (' + commentsText + ')';

          //scoreText += ' (' + scoreData['comments'].join(' | ') + ')';
				}

        row_items.push(scoreText);
      }
    })
    row_items.push(item.user_data.organization_name);
    row_items.push(item.user_data.organization_address);
    row_items.push(item.project_stage[1].last_name + ' ' + item.project_stage[1].first_name + ' ' + item.project_stage[1].patronymic);
    row_items.push(item.project_stage[1].region);

		res.push(row_items);

	})



  return res;
})
// to_excel_row_data() {
//   let res = this.pis;
//   const self = this;
//   res.forEach((item) => {
//
//     self.table_columns.forEach((column) => {
//
//       if (column.key.startsWith('scores_')) {
//         const votes = self.getVotes(item.newVotes, column.key.replace('scores_', ''));
//         let string = '';
//         votes.forEach((vote, index) => {
//           if (index < votes.length - 1) {
//             string += `${vote.expert} - ${vote.value} (${vote.comment}) | `;
//           } else {
//             string += `${vote.expert} - ${vote.value} (${vote.comment})`;
//           }
//         })
//         item[column.key] = string;
//       }
//     })
//
//     item['favorit'] = item.favorite ? 'Да' : '';
//   })
//
//
//   return this.pis;
// },

</script>

<style scoped>
.table_wrapper {
    position: relative;
    overflow-x: auto;
    width: 100%
}
.table_icons__wrapper {
    margin-top: 10px;
}
.table_icons__wrapper > span:not(:last-child) {
		margin-right: 10px;
}
.items {
    display: flex;
}

.items .item {
    margin-bottom: 35px;
    margin-right: 20px;
    cursor: pointer;
}

.items .item.active {
    border-bottom: 4px solid #F69400;
    padding-bottom: 10px;
}
</style>